"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _draftJs = require("draft-js"),
    _CommentTextEditor = _interopRequireWildcard(require("../../../../CommentTextEditor"));

require("../styles/_add-reply.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var AddReply = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.handleAddReply = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g, h, i, j, k, l;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              if (b = d.props, c = b.createReply, e = b.replyRef, f = b.clearInput, g = b.comment, h = b.comment.commentId, i = b.editorState, j = (0, _CommentTextEditor.getContentState)(i), k = j.json, l = j.plainText, l.trim()) {
                a.next = 4;
                break;
              }

              return a.abrupt("return");

            case 4:
              return d.setState({
                busy: !0
              }), a.next = 7, c({
                input: {
                  content: k,
                  parentId: h
                },
                parentComment: g
              });

            case 7:
              d.setState({
                busy: !1
              }), f(), e && e.scrollTo({
                top: e.scrollHeight,
                behavior: "smooth"
              });

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.state = {
      busy: !1
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.comment.isResolved,
          c = a.visible,
          d = a.onUpdateContent,
          e = a.editorState,
          f = a.resourceOrganisationId,
          g = this.state.busy,
          h = (0, _CommentTextEditor.getContentState)(e),
          i = h.plainText;
      return c ? _react["default"].createElement("div", {
        className: "add-reply"
      }, _react["default"].createElement(_CommentTextEditor["default"], {
        placeholder: "Enter reply",
        editorState: e,
        onUpdateContent: d,
        onSave: this.handleAddReply,
        disabled: b,
        organisationId: f,
        canDeleteAsset: !0
      }), _react["default"].createElement("div", {
        className: "add-reply__footer"
      }, _react["default"].createElement(_uiKit.Button, {
        onClick: this.handleAddReply,
        type: "SECONDARY",
        busy: g,
        disabled: !i.trim() || b
      }, "Submit"))) : null;
    }
  }]), b;
}(_react.Component);

AddReply.defaultProps = {
  visible: !0
};
var _default = AddReply;
exports["default"] = _default;